import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CarouselModule } from 'ngx-owl-carousel-o';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { AboutPageComponent } from './about-page/about-page.component';
import { ServicesPageComponent } from './services-page/services-page.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { ClientsPageComponent } from './clients-page/clients-page.component';
import { BlogsPageComponent } from './blogs-page/blogs-page.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FooterComponent } from './footer/footer.component';
import { ServiceDataAnalyticsComponent } from './services-page/service-subpages/service-data-analytics/service-data-analytics.component';
import { ServiceWebDevelopmentComponent } from './services-page/service-subpages/service-web-development/service-web-development.component';
import { ServiceSeoComponent } from './services-page/service-subpages/service-seo/service-seo.component';
import { ServiceEmailMarketingComponent } from './services-page/service-subpages/service-email-marketing/service-email-marketing.component';
import { ServiceSocialMarketingComponent } from './services-page/service-subpages/service-social-marketing/service-social-marketing.component';
import { ServiceIncreaseTrafficComponent } from './services-page/service-subpages/service-increase-traffic/service-increase-traffic.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ServiceGenericPostComponent } from './services-page/service-generic-post/service-generic-post.component';
import { ServiceContentMarketingComponent } from './services-page/service-subpages/service-content-marketing/service-content-marketing.component';
import { ServiceMarketingStrategiesComponent } from './services-page/service-subpages/service-marketing-strategies/service-marketing-strategies.component';
import { MatDialogModule } from '@angular/material/dialog';
import { ContactModalComponent } from './contact/contact-modal/contact-modal.component';
import { ContactFormComponent } from './contact/contact-form/contact-form.component';
import { AboutProcessComponent } from './about-page/about-process/about-process.component';
import { ModalMenuComponent } from './header/modal-menu/modal-menu.component';
import { AngularFireModule, FirebaseApp, FIREBASE_OPTIONS } from '@angular/fire/compat'
import { AngularFireFunctionsModule, ORIGIN, USE_EMULATOR } from '@angular/fire/compat/functions'
import { AppCheckModule, ReCaptchaV3Provider, provideAppCheck, initializeAppCheck } from '@angular/fire/app-check'
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RecaptchaV3Module, RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha'
import { environment } from 'src/environments/environment';
import { ContactFieldsComponent } from './contact/contact-fields/contact-fields.component';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { provideAnalytics, getAnalytics, ScreenTrackingService, initializeAnalytics} from '@angular/fire/analytics';
import { AngularFireAnalyticsModule } from '@angular/fire/compat/analytics';

const firebaseProviders = environment.production === true ? { provide: ORIGIN, useValue: environment.firebaseURL } : { provide: USE_EMULATOR, useValue: ['localhost', 5001] }
// const app = initializeApp(environment.firebase)
// const analytics = getAnalytics(app)
@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    ModalMenuComponent,
    LandingPageComponent,
    AboutPageComponent,
    ServicesPageComponent,
    NotFoundComponent,
    ClientsPageComponent,
    BlogsPageComponent,
    FooterComponent,
    ServiceDataAnalyticsComponent,
    ServiceWebDevelopmentComponent,
    ServiceSeoComponent,
    ServiceEmailMarketingComponent,
    ServiceSocialMarketingComponent,
    ServiceIncreaseTrafficComponent,
    ServiceGenericPostComponent,
    ServiceContentMarketingComponent,
    ServiceMarketingStrategiesComponent,
    ContactModalComponent,
    ContactFormComponent,
    AboutProcessComponent,
    ContactFieldsComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    AppRoutingModule,
    FlexLayoutModule,
    BrowserAnimationsModule,
    CarouselModule,
    AngularFireModule.initializeApp(environment.firebase),
    provideAppCheck(() =>
      initializeAppCheck(undefined, {
        provider: new ReCaptchaV3Provider(environment.recaptchaSiteKey),
        isTokenAutoRefreshEnabled: true,
      })
    ),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAnalytics(() => getAnalytics()),
    AngularFireAnalyticsModule,
    MatDialogModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    AngularFireFunctionsModule,
    RecaptchaV3Module
  ],
  providers: [
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: "6LexOq4hAAAAAG5JYzS2EL2j0tufqQOzQ2Q7bAW-" },
    { provide: FIREBASE_OPTIONS, useValue: environment.firebase },
    firebaseProviders,
    ScreenTrackingService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }


